import { Component } from "react";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#0a0f1a",
          color: "#e2e8f0",
          fontFamily: "'DM Mono', 'Courier New', monospace",
          padding: 32,
        }}>
          <div style={{ maxWidth: 500, textAlign: "center" }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>—</div>
            <div style={{ fontSize: 18, fontWeight: 700, marginBottom: 8, color: "#38bdf8" }}>
              Something went wrong
            </div>
            <div style={{ fontSize: 12, color: "#64748b", marginBottom: 24 }}>
              {this.state.error.message}
            </div>
            <button
              onClick={() => window.location.reload()}
              style={{
                background: "#0ea5e9",
                color: "#0a0f1a",
                border: "none",
                borderRadius: 4,
                padding: "9px 20px",
                fontWeight: 700,
                fontSize: 12,
                cursor: "pointer",
                fontFamily: "inherit",
                textTransform: "uppercase",
              }}
            >
              Reload Page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
